var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpayLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.718,
    height: 47.058,
    viewBox: "0 0 147.718 47.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spay_logo",
    transform: "translate(-65.168 -367.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tagline",
    transform: "translate(122.776 406.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M161.534,438.712v-1.79h.793a1.854,1.854,0,0,0,1.262-.4,1.619,1.619,0,0,0,.015-2.2,1.767,1.767,0,0,0-1.277-.414H160.58v4.808Zm1.277-3.832a.8.8,0,0,1,.191.562l.059-.015c0,.488-.279.725-.837.74h-.69v-1.479h.631A.963.963,0,0,1,162.811,434.881Z",
    transform: "translate(-160.58 -433.386)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M169.947,436.4a1.152,1.152,0,0,0-.484-.607,1.457,1.457,0,0,0-.807-.178,1.662,1.662,0,0,0-.851.222,1.565,1.565,0,0,0-.587.681,2.294,2.294,0,0,0-.22,1.036,2.219,2.219,0,0,0,.22,1.021,1.564,1.564,0,0,0,.587.68,1.663,1.663,0,0,0,.851.222,1.459,1.459,0,0,0,.807-.222,1.152,1.152,0,0,0,.484-.607v.74h.954v-3.7h-.954Zm-1.981,1.11a1.1,1.1,0,0,1,.279-.814.921.921,0,0,1,.7-.3.965.965,0,0,1,.719.3,1.145,1.145,0,0,1,.279.814,1.07,1.07,0,0,1-.279.784.921.921,0,0,1-.719.3.906.906,0,0,1-.7-.281A1.085,1.085,0,0,1,167.965,437.514Z",
    transform: "translate(-163.122 -434.067)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M175.249,435.745l1.027,2.559.939-2.559h1.057l-2.289,5.577h-1.057l.837-1.908-1.57-3.669h1.057Z",
    transform: "translate(-165.973 -434.118)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M187.52,435.99a1.7,1.7,0,0,1,.4,1.213v2.189h-.939v-2.086a.937.937,0,0,0-.22-.666.774.774,0,0,0-.6-.237.876.876,0,0,0-.646.251,1.086,1.086,0,0,0-.235.74v2h-.939v-2.086a.937.937,0,0,0-.22-.666.774.774,0,0,0-.6-.237.862.862,0,0,0-.646.251,1.011,1.011,0,0,0-.235.74v2h-.954v-3.7h.954v.71a1.255,1.255,0,0,1,.47-.562,1.458,1.458,0,0,1,1.541,0,1.477,1.477,0,0,1,.5.621,1.476,1.476,0,0,1,.528-.607,1.313,1.313,0,0,1,.778-.237A1.46,1.46,0,0,1,187.52,435.99Z",
    transform: "translate(-168.94 -434.067)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M194.027,437.665h2.744a1.492,1.492,0,0,0,.044-.326,2,2,0,0,0-.235-.932,1.679,1.679,0,0,0-.646-.636,2.229,2.229,0,0,0-1.937,0,1.547,1.547,0,0,0-.66.68,2.369,2.369,0,0,0,0,2.056,1.474,1.474,0,0,0,.66.666,1.882,1.882,0,0,0,.969.237,2,2,0,0,0,.851-.178,1.733,1.733,0,0,0,.631-.488,1.486,1.486,0,0,0,.308-.71h-1a.77.77,0,0,1-.279.444.861.861,0,0,1-.558.163.833.833,0,0,1-.616-.237A1.011,1.011,0,0,1,194.027,437.665Zm.294-1.124a1.006,1.006,0,0,1,1.292,0,.847.847,0,0,1,.235.7h-1.82A.98.98,0,0,1,194.321,436.541Z",
    transform: "translate(-173.466 -434.04)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M203.629,436a1.74,1.74,0,0,1,.382,1.213V439.4h-.939v-2.086a.952.952,0,0,0-.235-.7.818.818,0,0,0-.631-.251.833.833,0,0,0-.646.266,1.1,1.1,0,0,0-.249.769v2h-.939v-3.7h.939v.754a1.166,1.166,0,0,1,.5-.592,1.459,1.459,0,0,1,.792-.222,1.314,1.314,0,0,1,1.027.355Z",
    transform: "translate(-176.346 -434.075)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M209.534,438v.828h-.44a1.358,1.358,0,0,1-.969-.311,1.309,1.309,0,0,1-.338-1.021v-1.627h-.514v-.74h.514V434.2h.954v.932h.792v.814H208.7v1.642a.521.521,0,0,0,.117.385.452.452,0,0,0,.352.1Z",
    transform: "translate(-179.081 -433.506)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M217.687,438.029a1.472,1.472,0,0,1-.543.5,1.953,1.953,0,0,1-.881.178,2.42,2.42,0,0,1-.9-.163,1.572,1.572,0,0,1-.646-.5,1.383,1.383,0,0,1-.264-.769h1.013a.708.708,0,0,0,.763.681.569.569,0,0,0,.455-.163.6.6,0,0,0,.029-.784,1.042,1.042,0,0,0-.323-.222l-.543-.207-.734-.3a1.339,1.339,0,0,1-.484-.429,1.235,1.235,0,0,1-.191-.725,1.187,1.187,0,0,1,.44-.976,1.723,1.723,0,0,1,1.174-.37,1.912,1.912,0,0,1,1.2.37,1.483,1.483,0,0,1,.514.991h-1a.712.712,0,0,0-.22-.429.657.657,0,0,0-.484-.177.672.672,0,0,0-.426.148.505.505,0,0,0-.161.4.475.475,0,0,0,.132.355.969.969,0,0,0,.308.222l.528.207a4.826,4.826,0,0,1,.748.311,1.221,1.221,0,0,1,.484.429,1.16,1.16,0,0,1,.205.74,1.339,1.339,0,0,1-.205.681Z",
    transform: "translate(-181.921 -433.339)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M221.691,433.05a.643.643,0,0,0-.426.148.521.521,0,0,0,0,.754.643.643,0,0,0,.426.148.672.672,0,0,0,.426-.148.5.5,0,0,0,.161-.37.52.52,0,0,0-.161-.385A.672.672,0,0,0,221.691,433.05Zm.47,5.326v-3.7h-.954v3.7Z",
    transform: "translate(-184.56 -433.05)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M230.13,436a1.7,1.7,0,0,1,.4,1.213v2.19h-.939v-2.086a.937.937,0,0,0-.22-.666.789.789,0,0,0-.616-.237.848.848,0,0,0-.631.252,1.011,1.011,0,0,0-.235.74v2h-.939v-2.086a.937.937,0,0,0-.22-.666.789.789,0,0,0-.616-.237.848.848,0,0,0-.631.252,1.011,1.011,0,0,0-.235.74v2h-.954v-3.7h.954v.71a1.166,1.166,0,0,1,.47-.562,1.491,1.491,0,0,1,1.541.015,1.477,1.477,0,0,1,.5.621,1.476,1.476,0,0,1,.528-.607,1.284,1.284,0,0,1,.778-.237,1.46,1.46,0,0,1,1.071.355Z",
    transform: "translate(-185.823 -434.076)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M239.689,436.5a1.309,1.309,0,0,0-1.438-.828,1.459,1.459,0,0,0-.807.222,1.315,1.315,0,0,0-.484.607v-.784H236v5.5h.954v-2.589a1.314,1.314,0,0,0,.484.607,1.459,1.459,0,0,0,.807.222,1.495,1.495,0,0,0,1.438-.9,2.219,2.219,0,0,0,.22-1.021A2.294,2.294,0,0,0,239.689,436.5Zm-2.73,1.036a1.145,1.145,0,0,1,.279-.814.965.965,0,0,1,.719-.3.921.921,0,0,1,.7.3,1.1,1.1,0,0,1,.279.814,1.085,1.085,0,0,1-.279.8.906.906,0,0,1-.7.281.921.921,0,0,1-.719-.3A1.07,1.07,0,0,1,236.959,437.531Z",
    transform: "translate(-190.465 -434.084)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M244.542,433.516v5.045h-.954v-5.045Z",
    transform: "translate(-193.47 -433.234)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M246.995,433.05a.672.672,0,0,0-.426.148.52.52,0,0,0-.161.385.5.5,0,0,0,.161.37.672.672,0,0,0,.426.148.643.643,0,0,0,.426-.148.521.521,0,0,0,0-.754A.643.643,0,0,0,246.995,433.05Zm.484,5.326v-3.7h-.954v3.7Z",
    transform: "translate(-194.587 -433.05)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M250.686,434.156a.684.684,0,0,0-.176.533h.763v.814h-.763v2.959h-.91V435.5h-.47v-.74h.47v-.089a1.382,1.382,0,0,1,.382-1.036,1.562,1.562,0,0,1,1.13-.37h.205v.828a.728.728,0,0,0-.631.059Z",
    transform: "translate(-195.666 -433.135)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M254.02,433.05a.672.672,0,0,0-.426.148.52.52,0,0,0-.161.385.5.5,0,0,0,.161.37.672.672,0,0,0,.426.148.643.643,0,0,0,.426-.148.521.521,0,0,0,0-.754A.643.643,0,0,0,254.02,433.05Zm.47,5.326v-3.7h-.939v3.7Z",
    transform: "translate(-197.37 -433.05)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M257.25,437.665h2.744a1.492,1.492,0,0,0,.044-.326,2,2,0,0,0-.235-.932,1.679,1.679,0,0,0-.646-.636,2.229,2.229,0,0,0-1.937,0,1.548,1.548,0,0,0-.66.68,2.369,2.369,0,0,0,0,2.056,1.474,1.474,0,0,0,.66.666,1.882,1.882,0,0,0,.969.237,2,2,0,0,0,.851-.178,1.733,1.733,0,0,0,.631-.488,1.485,1.485,0,0,0,.308-.71h-1a.726.726,0,0,1-.294.444.788.788,0,0,1-.543.163.833.833,0,0,1-.616-.237A1.011,1.011,0,0,1,257.25,437.665Zm.294-1.124a.992.992,0,0,1,1.291,0,.892.892,0,0,1,.235.7h-1.82A.98.98,0,0,1,257.544,436.541Z",
    transform: "translate(-198.517 -434.04)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M266.211,435.572a1.152,1.152,0,0,0-.484-.607,1.458,1.458,0,0,0-.792-.178,1.721,1.721,0,0,0-.866.222,1.667,1.667,0,0,0-.587.681,2.294,2.294,0,0,0-.205,1.036,2.219,2.219,0,0,0,.205,1.021,1.668,1.668,0,0,0,.587.681,1.72,1.72,0,0,0,.866.222,1.459,1.459,0,0,0,.792-.222,1.152,1.152,0,0,0,.484-.607v.74h.954v-5.044h-.954v2.056Zm-1.981,1.11a1.16,1.16,0,0,1,.279-.814.95.95,0,0,1,.719-.3.936.936,0,0,1,.7.3,1.145,1.145,0,0,1,.279.814,1.07,1.07,0,0,1-.279.784.892.892,0,0,1-.7.3.935.935,0,0,1-.719-.281A1.145,1.145,0,0,1,264.229,436.681Z",
    transform: "translate(-201.27 -433.234)",
    fill: "#150958",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logotype",
    transform: "translate(116.539 370.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M150.25,396.954l5.445-3.432a6.5,6.5,0,0,0,6,3.92c2.289,0,3.7-1.11,3.7-2.766,0-5.3-13.854-2.826-13.854-13.122,0-6.051,4.843-8.876,9.6-8.876a12.258,12.258,0,0,1,9.261,4.29l-4.4,4.2a6.809,6.809,0,0,0-4.9-2.618c-1.6,0-2.935.8-2.935,2.515,0,5.252,13.81,2.471,13.81,13.669,0,5.651-4.755,8.98-10.361,8.98a12.753,12.753,0,0,1-11.359-6.761Z",
    transform: "translate(-150.25 -372.278)",
    fill: "#00aeef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M204.625,372.031H192.884v31.422h6.545V392.416h5.254a9.556,9.556,0,0,0,7.28-2.831,11.1,11.1,0,0,0-.013-14.731,9.571,9.571,0,0,0-7.325-2.823Zm2.611,12.812a3.3,3.3,0,0,1-2.611.932l-5.2.059v-7.16H204.7a3.3,3.3,0,0,1,2.573.971,3.932,3.932,0,0,1-.036,5.2Z",
    transform: "translate(-167.143 -372.016)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M240.369,388.43a10.98,10.98,0,0,0,.1,21.939,9.226,9.226,0,0,0,5.87-1.894v1.479h6.091V388.888H245.9v1.243a9.034,9.034,0,0,0-5.533-1.7Zm.949,6.214a4.82,4.82,0,0,1,3.455,8.164,4.692,4.692,0,0,1-3.378,1.422,4.793,4.793,0,0,1-.078-9.586Z",
    transform: "translate(-181.885 -378.518)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M294.753,389.192l-11.917,29.972h-6.795l3.845-9.912-8.1-20.06h7.147l4.4,11.968,4.417-11.968Z",
    transform: "translate(-198.405 -378.822)",
    fill: "#150958",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logotype-2",
    "data-name": "Logotype",
    transform: "translate(65.168 367.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M106.383,378.508H87.539a1.072,1.072,0,0,1-.928-.695,1.086,1.086,0,0,1,.238-1.14l7.338-7.4a7.559,7.559,0,0,1,10.728,0l3.669,3.891a3.155,3.155,0,0,1,.66,3.408,3.111,3.111,0,0,1-2.861,1.933Z",
    transform: "translate(-73.637 -367.044)",
    fill: "#00aeef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M85.454,424.865H104.3a1.071,1.071,0,0,1,.985.662,1.086,1.086,0,0,1-.221,1.172l-7.338,7.4a7.545,7.545,0,0,1-10.714,0l-3.8-3.846a3.139,3.139,0,0,1-.725-3.475,3.1,3.1,0,0,1,2.97-1.91Z",
    transform: "translate(-71.933 -389.953)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M83.995,406.931h32.038c1.468,0,2.113,2.175,1.115,3.447l-3.9,4.985a1.464,1.464,0,0,1-1.115.592H87.9a1.464,1.464,0,0,1-1.115-.592l-3.9-4.985c-1-1.272-.294-3.447,1.115-3.447Z",
    transform: "translate(-72 -382.848)",
    fill: "#150958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M65.657,394.6l4.08-5a1.463,1.463,0,0,1,1.159-.577H96.271a1.464,1.464,0,0,1,1.159.577l4.08,5c1.042,1.272.352,3.4-1.115,3.4H66.831c-1.482,0-2.216-2.13-1.174-3.4Z",
    transform: "translate(-65.168 -375.751)",
    fill: "#150958",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpayLogo);
export default __webpack_public_path__ + "static/media/spay_logo.6cb46decb377a948e9648808a0c9e745.svg";
export { ForwardRef as ReactComponent };